// Vue core
import Vue from 'vue';
import App from '@/App';
import store from '@/store';
import router from '@/router';
import { ObserveVisibility } from 'vue-observe-visibility';

// Plugins & libs
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/styles/fonts.css';

import Vuetify from 'vuetify/lib';
import PortalVue from 'portal-vue';
import VueLazyload from 'vue-lazyload';
import './registerServiceWorker';

import initEmbedly from '@/lib/embedly';
import initSegment from '@/lib/segment';
import i18n from './lib/i18n';
import { vueEnv } from '@/globals';

import mixins from '@/mixins';
import theme from '@/factories/theme';
import { sync } from 'vuex-router-sync';
import lackey from '@/dev/lackey';
import safeHtml from '@/directives/safeHtml';

sync(store, router);
Vue.mixin(mixins);
Vue.use(PortalVue);
Vue.use(Vuetify);
Vue.use(VueLazyload);
Vue.directive('observe-visibility', ObserveVisibility);
Vue.directive('safe-html', safeHtml);

const initApp = () => {
  return new Vue({
    el: '#app',
    store,
    router,
    vuetify: new Vuetify(theme.getVuetifyBaseConfig()),
    template: '<App/>',
    i18n,
    components: { App },
  });
};

const bootstrap = () => {
  theme.once('customThemeSet', () => {
    lackey.connect({ port: process.env.VUE_APP_LACKEY_PORT });
    const vm = initApp();
    initEmbedly();

    lackey.channel('app', () => ({ store, router, theme, vm }));
    lackey.channel('dom', () => window);
  });

  theme.setCustomTheme();
};

// Only load and use defender for apex.vmcteam.com
const isApex = window.location.hostname === 'apex.vmcteam.com';

if (isApex) {
  // Dynamic import ensures defender is only loaded for apex domain
  import('@dataunlocker/defender')
    .then(({ onLoad, onError }) => {
      onLoad(() => {
        console.info('[Defender] loaded successfully');
        const segmentKey = vueEnv('vector_apex_segment_key');
        if (segmentKey) {
          initSegment(segmentKey);
        }
        bootstrap();
      });

      onError((error) => {
        console.error('[Defender] error during load', error);
        bootstrap(); // Graceful fallback if Defender fails
      });
    })
    .catch((error) => {
      console.error('[Defender] failed to import module', error);
      bootstrap(); // Fallback if import itself fails
    });
} else {
  // Skip defender entirely for non-apex domains
  bootstrap();
}
